import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const Dropdown = ({ label, value, options, onChange,getOptionLabel, getOptionValue }) => {
  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel size="small">{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        size="small"
      >
        {options.map((opt) => (
          // <MenuItem key={opt.id || opt} value={opt.id || opt}>
          //   {opt.name || opt}
          // </MenuItem>
          <MenuItem key={getOptionValue(opt)} value={getOptionValue(opt)}>
            {getOptionLabel(opt)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;